module.exports = __webpack_public_path__ + "img/04d_color.8abcf503.png";